// src/components/tour/tours/index.js
//
// Registry of every page tour. To add a page:
//   1. write tours/<page>.jsx exporting a getSteps(ctx, env) function
//   2. add it below
//   3. in the page: usePageTour('<id>', { ...liveData })
//   4. put data-tour="..." on the elements the steps point at
//
// Step filters (all optional), applied here so tour files stay simple:
//   scopes: ['admin'] | ['client']    -> FleetHeader's scope (internal vs client)
//   roles:  ['admin', 'operator', ...] -> user.role
//   layout: 'mobile' | 'desktop'
//   when:   (ctx, env) => boolean     -> anything else (e.g. period === 'daily')

import { getDeviceManagerSteps } from './deviceManager';
import { getMonitoringSteps } from './monitoring';
import { getSiteDashboardSteps } from './siteDashboard';
import { getAlertsSteps } from './alerts';
import { getClientManagerSteps } from './clientManager';
import { getAdminManagerSteps } from './adminManager';
import { getSiteManagerSteps } from './siteManager';
import { getSitesMapSteps } from './sitesMap';
import { getStarlinkSteps } from './starlink';
import { getAuditLogSteps } from './auditLog';
import { getUserManagerSteps } from './userManager';

export const TOURS = {
    'device-manager': getDeviceManagerSteps,
    monitoring: getMonitoringSteps,
    'site-dashboard': getSiteDashboardSteps, // SiteDashboard + ClientSiteDashboard
    alerts: getAlertsSteps,                   // AlertDashboard (admin + client)
    'client-manager': getClientManagerSteps,
    'admin-manager': getAdminManagerSteps,
    'site-manager': getSiteManagerSteps,
    'sites-map': getSitesMapSteps,
    starlink: getStarlinkSteps,               // StarlinkDevicePage (admin + client)
    'audit-log': getAuditLogSteps,
    'user-manager': getUserManagerSteps,      // ClientAdminManager (client admins)
};

export function buildTourSteps(id, ctx, env) {
    const getSteps = TOURS[id];
    if (!getSteps) return [];
    return getSteps(ctx || {}, env).filter((s) => {
        if (!s) return false;
        if (s.scopes && !s.scopes.includes(env.scope)) return false;
        if (s.roles && !s.roles.includes(env.role)) return false;
        if (s.layout === 'mobile' && !env.isMobile) return false;
        if (s.layout === 'desktop' && env.isMobile) return false;
        if (s.when && !s.when(ctx, env)) return false;
        return true;
    });
}
